import { useEffect } from 'react';
import client from '@/store/client';

const McpSquare = ({ className = '' }) => {
  const url = client.is360se ? 'https://browser.360.cn/ai/mcpsquare-se.html' : 'https://browser.360.cn/ai/mcpsquare.html'
  return (
    <div className="size-full">
      <iframe
        style={{ width: '100%', height: '100%' }}
        allow="camera *;microphone *;clipboard-write"
        src={url}
      />
    </div>
  );
};

export default McpSquare;
